import loadable from '@loadable/component'

export default [
  {
    path: '/gameRoom/BigWheel',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-gameRoom-BigWheel" */ '~/pages/game/gameRoom/BigWheel'
        )
    ),
  },
  {
    path: '/gameRoom/BigWheel/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-gameRoom-BigWheel-rule" */ '~/pages/game/gameRoom/BigWheel/components/Rule'
        )
    ),
  },
]
